exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shipping-method[data-v-78f392a5]{margin-bottom:2em}.shipping-method .radio_choose[data-v-78f392a5]{margin-right:0;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:7px}.shipping-method .radio_choose .form_radio[data-v-78f392a5]{margin:0 0 0 20px}.shipping-method .radio_choose .form_radio .shipping-price span[data-v-78f392a5]{color:#1e824c;font-weight:700}.birthday-warp hr[data-v-78f392a5]{margin:20px 0}", ""]);

// exports
